/** Web storage stand-in for react-native-keychain (no biometrics on PWA). */
export const ACCESS_CONTROL = {
  BIOMETRY_ANY: 'BiometryAny',
  BIOMETRY_CURRENT_SET: 'BiometryCurrentSet',
  DEVICE_PASSCODE: 'DevicePasscode',
};

export const ACCESSIBLE = {
  WHEN_UNLOCKED: 'AccessibleWhenUnlocked',
  AFTER_FIRST_UNLOCK: 'AccessibleAfterFirstUnlock',
};

export const BIOMETRY_TYPE = {
  TOUCH_ID: 'TouchID',
  FACE_ID: 'FaceID',
  FINGERPRINT: 'Fingerprint',
  FACE: 'Face',
  IRIS: 'Iris',
} as const;

export async function setGenericPassword(
  _username?: string,
  _password?: string,
  _options?: unknown,
) {
  return false;
}

export async function getGenericPassword(_options?: unknown) {
  return false as const;
}

export async function resetGenericPassword(_options?: unknown) {
  return false;
}

/** PWA has no device biometry — always null so Face ID / fingerprint flows stay off. */
export async function getSupportedBiometryType() {
  return null;
}

export async function canImplyAuthentication() {
  return false;
}

export async function getSecurityLevel() {
  return null;
}

const Keychain = {
  setGenericPassword,
  getGenericPassword,
  resetGenericPassword,
  getSupportedBiometryType,
  canImplyAuthentication,
  getSecurityLevel,
  ACCESS_CONTROL,
  ACCESSIBLE,
  BIOMETRY_TYPE,
};

export default Keychain;
